import React from 'react';
import spinner from '../assets/img/spinner.svg';

const styles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    zIndex: 50,
  },
  spinner: {
    height: '6rem', // h-24
  },
};

const Spinner = () => {
  return (
    <div style={styles.overlay}>
      <div>
        <img src={spinner} alt="Loading" style={styles.spinner} />
      </div>
    </div>
  );
};



export default Spinner;
